// Best-effort cancellation of the browser push subscription, safe to call from
// any logout path (manual logout and the session-expiry hard redirects).
//
// This module intentionally imports nothing from the api/axios graph so that
// axiosInstance.js and tokenManager.js can import it without an import cycle.

// Kept in sync with DEVICE_NAME_COOKIE in utils/push.js (duplicated to keep
// this module free of the api/axios import graph).
const DEVICE_NAME_COOKIE = "device_name";

export async function cancelPushSubscription() {
  const work = (async () => {
    document.cookie = `${DEVICE_NAME_COOKIE}=; path=/; max-age=0`;
    if (!("serviceWorker" in navigator)) return;
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    if (subscription) await subscription.unsubscribe();
  })().catch((e) => console.error("Push cleanup failed:", e));

  // Don't let a stuck unsubscribe block the login redirect.
  await Promise.race([
    work,
    new Promise((resolve) => setTimeout(resolve, 1000)),
  ]);
}
